import { useStateSafe } from '@effects/useStateSafe';
import { createContext, useContextSelector } from 'use-context-selector';
import { STEPS } from '@constant/steps';

export const MainContext = createContext(null);

const MainContextProvider = ({ children }) => {
	const [currentStep, setCurrentStep] = useStateSafe<number>(STEPS.START_TRACKING);

	const contextProps = {
		currentStep,
		setCurrentStep
	};

	return <MainContext.Provider value={contextProps}>{children}</MainContext.Provider>;
};

export const useCurrentStep = () => useContextSelector(MainContext, (s) => s.currentStep);
export const useSetCurrentStep = () => useContextSelector(MainContext, (s) => s.setCurrentStep);

export default MainContextProvider;
